export const LuhnChecksum = {
  /**
   * Checks whether the given input is a valid Luhn checksum.
   *
   * The given input must only contain numbers. The behaviour is otherwise undefined.
   */
  verify(input: string): boolean {
    let sum = 0;
    const parity = (input.length - 2) % 2;

    for (let i = 0; i < input.length; i++) {
      let digit = Number(input[i]);

      if (i % 2 === parity) {
        digit = digit * 2;
      }

      if (digit > 9) {
        digit -= 9;
      }

      sum += digit;
    }

    return sum % 10 === 0;
  },
};
